// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ContentFeedback-cls1__f83fc4560146421b9738{/*!*/}.ContentFeedback-cls2__d8e48c38db5774051305{cursor:pointer;color:#0c3b8d}.ContentFeedback-cls2__d8e48c38db5774051305:hover,.ContentFeedback-cls2__d8e48c38db5774051305:focus{text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ContentFeedback-cls1__f83fc4560146421b9738",
	"cls2": "ContentFeedback-cls2__d8e48c38db5774051305 ContentFeedback-cls1__f83fc4560146421b9738"
};
export default ___CSS_LOADER_EXPORT___;
